import { render, staticRenderFns } from "./Metadata.vue?vue&type=template&id=53823512&scoped=true&"
import script from "./Metadata.vue?vue&type=script&lang=js&"
export * from "./Metadata.vue?vue&type=script&lang=js&"
import style0 from "./Metadata.vue?vue&type=style&index=0&id=53823512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53823512",
  null
  
)

component.options.__file = "Metadata.vue"
export default component.exports